import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { Card, EmptyState } from "@/components/ui";

import { findRoute } from "../../app/routes";

/**
 * Stands in for every screen not yet built.
 *
 * Honest rather than decorative: it names the delivery phase, so a merchant or a
 * reviewer clicking through the shell can tell "not built yet" from "broken".
 * That distinction is worth a component — an unexplained blank screen during a
 * demo reads as a defect, and it is remembered as one.
 *
 * Each of these is replaced by a real feature module in its phase; the shell,
 * routing and navigation around it do not change.
 */
export function PlaceholderPage() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const route = findRoute(pathname);

  if (!route) return null;

  return (
    <Card flush>
      <EmptyState
        icon={route.icon}
        title={t("placeholder.title", { screen: route.label })}
        description={
          <>
            {route.subtitle}.{" "}
            <span className="font-medium text-ink-600">
              {t("placeholder.scheduled", { phase: route.phase })}
            </span>
          </>
        }
      />
    </Card>
  );
}
